export class OpenFloorPlanWarningNotAccepted {
  constructor() {}
}
